export default {
  header: [],
  table: {
    noDateRange: true,
    disableSavingTableSettings: true,
    specialFlag: {
      endpoint: 'reports/drivers'
    },
    sorting: {
      sortBy: 'driver',
      sortDesc: false
    },
    filters: [],
    parameters: [
      { name: 'driver', text: 'Kierowca', value: 'driver', show: true, sortable: true },
      { name: 'averageLoopLength', text: 'Średnia długość pętli', value: 'averageLoopLength', show: true, sortable: false },
      { name: 'averageLoopTime', text: 'Średni czas pętli', value: 'averageLoopTime', show: true, sortable: false },
      { name: 'averageWorkTime', text: 'Średni czas pracy', value: 'averageWorkTime', show: true, sortable: false },
      { name: 'averageLoops', text: 'Średnia ilość pętli', value: 'averageLoops', show: true, sortable: false },
      { name: 'absoluteLoops', text: 'Pętla bezwzględna', value: 'absoluteLoops', show: true, sortable: false },
      { name: 'vehicleType', text: 'Typ pojazdu', value: 'vehicleType', show: true, sortable: false }
    ],
    actions: [],
    menu: []
  },
  details: {
    title: '',
    actions: [],
    sections: []
  }
}
